import { Pipe, PipeTransform } from '@angular/core';
import { AppContext } from '../services/context/app.context.service';
import { COUNTRY_TZ, DATETIME_DEFAULT_FORMAT } from '@shared/types/enums';
import moment from 'moment-timezone';

@Pipe({
  name: 'formatDateTz',
})
export class FormatDateTzPipe implements PipeTransform {
  constructor(private readonly _appCtxSvc: AppContext) {}

  transform(value: any): string {
    try {
      const regex = /\//g;
      const newDate = value.replace(regex, '-');
      
      return moment.tz(newDate, COUNTRY_TZ[this._appCtxSvc.getCountry()]).format(DATETIME_DEFAULT_FORMAT);
    } catch (error) {
      throw error;
    }
  }
}
